module.exports = __webpack_public_path__ + "static/img/y3.843d1c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/y3.png
// module id = ZUgo
// module chunks = 10